
import { Vue, Component, Prop } from "vue-property-decorator";

import LIST_PROJECTS from "@/apollo/projects/ListProjects.gql";

import CardPagination from "@/components/card/CardPagination.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import ContractorChips from "@/components/companyProjects/ContractorChips.vue";
import CardBodyItem from "@/components/card/CardBodyItemNew.vue";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholderNew.vue";
import ProjectContractorsCardItem from "@/components/projects/ProjectContractorsCardItem.vue";
import AddContractorToProject from "@/components/contractors/AddContractorToProjectNew.vue";
import UiButtonMessage from "@/components/button/ui-button-message.vue";
import PaginationConfig from "@/entities/PaginationConfig";
import paginationConfig from "@/data/paginationConfig";
import EmptyListImageProjects from "@/components/icons/emptyListImages/EmptyListImageProjects.vue";
import ProjectCollection from "@/components/projects/ProjectCollectionNew.vue";
import ProjectCard from "@/components/projects/ProjectCardNew.vue";
import { Project, User } from "@/generated/graphql";
import CardsContainer from "@/components/card/cardsContainerDeatils.vue";
import ElementsSizeProvider from "@/components/uiSize/ElementsSizeProvider.vue";

@Component({
  components: {
    EmptyListImageProjects,
    ProjectCollection,
    CardPagination,
    EmptyListPlaceholder,
    LoadingOverlay,
    ContractorChips,
    CardBodyItem,
    UiButtonMessage,
    ProjectCard,
    CardsContainer,
    ElementsSizeProvider,
    ProjectContractorsCardItem,
    AddContractorToProject,
  },
  apollo: {
    projects: {
      query: LIST_PROJECTS,
      variables() {
        return this.contractorProjectsArgs;
      },
      update(data) {
        this.paginationConfig.total = data.total.aggregate.count;
        this.paginationConfig.loadedCount = data.project.length;
        return data.project;
      },
    },
  },
})
export default class Projects extends Vue {
  @Prop({ type: String, required: true }) readonly contractorUserId!: string;
  @Prop({ type: String, required: true }) readonly contractorId!: string;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: String, required: true }) readonly contractorFullName!: string;
  @Prop({ type: String, required: true }) readonly companyId!: string;

  paginationConfig: PaginationConfig = { ...paginationConfig };

  projects: Project[]  = [];
  modalOpened: boolean = false;

  get contractorProjectsArgs(): any {
    const { page, limit } = this.paginationConfig;
    const nextOffset = page * limit - limit;
    const queryTemplate = {
      offset: nextOffset,
      // limit: limit,
      where: {},
    };

    const generalCondition = {
      project_activities: {
        contractor: {
          user_id: {
            _eq: this.contractorUserId,
          },
        },
      },
    };

    if (this.currentUser.role === "MANAGER") {
      queryTemplate.where = {
        _and: [
          generalCondition,
          {
            project_activities: {
              project: {
                manager: {
                  user_id: {
                    _eq: this.currentUser.id,
                  },
                },
              },
            },
          },
        ],
      };

      return queryTemplate;
    }

    queryTemplate.where = {
      _and: [
        generalCondition,
        {
          company: {
            admins: {
              user_id: {
                _eq: this.currentUser.id,
              },
            },
          },
        },
      ],
    };

    return queryTemplate;
  }

  get completedProjects(): Project[] {
    return this.projects?.filter((project) => project.completed);
  }
  get activeProjects(): Project[] {
    return this.projects?.filter((project) => !project.completed && !project.drafted);
  }
   get draftProjects(): Project[] {
    return this.projects?.filter((project) => !project.completed && project.drafted);
  }
  get isProjectsExist(): boolean {
    if (this.projects) {
      return this.projects?.length > 0;
    }
    return false;
  }


  get emptyListSubtitle(): string {
    return `Start adding clients to ${this.contractorFullName}`;
  }

  refetchCollection(): void {
    this.$apollo.queries.projects.refetch();
  }
}
